"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserRole;
(function (UserRole) {
    UserRole["None"] = "None";
    UserRole["NormalDelegate"] = "NormalDelegate";
    UserRole["AdminDelegate"] = "AdminDelegate";
    UserRole["EtaAdmin"] = "EtaAdmin";
    UserRole["ProcessAdministrators"] = "ProcessAdministrators";
    UserRole["ITOperators"] = "ITOperators";
    UserRole["DataAnalysts"] = "DataAnalysts";
    UserRole["GovDecisionMaker"] = "GovDecisionMaker";
    UserRole["SystemAuditors"] = "SystemAuditors";
    UserRole["TaxAuditors"] = "TaxAuditors";
    UserRole["ServiceCenterAssistants"] = "ServiceCenterAssistants";
    UserRole["All"] = "All";
    UserRole["ReviewerOfficer"] = "ReviewerOfficer";
    UserRole["ComplainOfficer"] = "ComplainOfficer";
    UserRole["CoreTaxAuditor"] = "CoreTaxAuditor";
    UserRole["TaxpayerTagsManager"] = "TaxpayerTagsManager";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
//# sourceMappingURL=EnumRole.js.map